import apiService from './apiService';

export const uploadsService = {
  // ==================== Avatar ====================

  async getAvatar(): Promise<any> {
    return apiService.get('/uploads/avatar');
  },

  async uploadAvatar(file: File): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);

    return apiService.post('/uploads/avatar', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  async getDiceBearAvatar(params?: { seed?: string; style?: string }): Promise<any> {
    return apiService.get('/uploads/dicebear', { params });
  },

  async generateAvatar(format: 'svg' | 'png' = 'svg'): Promise<any> {
    return apiService.post('/uploads/avatar/generate', { format });
  },

  // ==================== General Uploads ====================

  async uploadAttachment(file: File, metadata?: { context?: string; relatedId?: string }): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
    if (metadata?.context) {
      formData.append('context', metadata.context);
    }
    if (metadata?.relatedId) {
      formData.append('relatedId', metadata.relatedId);
    }

    return apiService.post('/uploads/attachment', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  async getSignedUrl(key: string, params?: { expiresIn?: number }): Promise<any> {
    return apiService.get(`/uploads/signed-url/${key}`, { params });
  },

  async deleteFile(key: string): Promise<void> {
    return apiService.delete(`/uploads/${key}`);
  },
};
